import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { store } from './redux-store/store';
import { Provider } from 'react-redux';
import {BrowserRouter} from "react-router-dom";
import './index.scss';

ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter basename='/'>
          <App/>
      </BrowserRouter>
    </Provider>,
  document.getElementById('root')
);
